/**
 * Haptic feedback utilities for mobile devices
 * Provides tactile feedback for user interactions
 */

export const haptics = {
  /**
   * Light tap - for subtle interactions (navigation, selection)
   */
  light: () => {
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  },

  /**
   * Medium tap - for standard interactions (button clicks, toggles)
   */
  medium: () => {
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  },

  /**
   * Heavy tap - for important actions (confirmations, deletions)
   */
  heavy: () => {
    if (navigator.vibrate) {
      navigator.vibrate(30);
    }
  },

  /**
   * Success pattern - for successful operations
   */
  success: () => {
    if (navigator.vibrate) {
      navigator.vibrate([10, 50, 10]);
    }
  },

  /**
   * Error pattern - for failed operations or warnings
   */
  error: () => {
    if (navigator.vibrate) {
      navigator.vibrate([20, 100, 20, 100]);
    }
  },

  /**
   * Notification pattern - for alerts and notifications
   */
  notification: () => {
    if (navigator.vibrate) {
      navigator.vibrate([10, 100, 10, 100, 10]);
    }
  }
};
